import EditDrawer from './EditDrawer/EditDrawer';
import GridHandler from './GridHandler/GridHandler';
import InjectOrder from './InjectOrder/InjectOrder';
import InjectBaselineAffectation from './InjectBaselineAffectation/InjectBaselineAffectation';
import InjectScopes from './InjectScopes/InjectScopes';
import SelectItems from './SelectItems/SelectItems';
import SetAffectationClients from './SetAffectationClients/SetAffectationClients';
import SetAffectationConsultants from './SetAffectationConsultants/SetAffectationConsultants';
import SetAffectationDM from './SetAffectationDM/SetAffectationDM';
import UpdateBaseline from './UpdateBaseline/UpdateBaseline';
import UpdateSearch from './UpdateSearch/UpdateSearch';

const ReduceReducers =
  (...reducers: any[]) =>
  (prevState: any, value: any, ...args: any) =>
    reducers.reduce((newState, reducer) => reducer(newState, value, ...args), prevState);

export default ReduceReducers(
  EditDrawer,
  GridHandler,
  InjectOrder,
  InjectBaselineAffectation,
  InjectScopes,
  SelectItems,
  SetAffectationClients,
  SetAffectationConsultants,
  UpdateBaseline,
  UpdateSearch,
  SetAffectationDM
);
